module.exports = __webpack_public_path__ + "static/media/acacia-mall-interior.dc4be09b.webp";